import { defineStore } from 'pinia';
import { Store } from '@/setup/globals';
import { setInitialData } from '@/stores/plugins/initial-data';
import { BreadcrumbItem } from '@/types/breadcrumb';

export type StoreState = {
  items: BreadcrumbItem[];
};

const storeName = Store.Breadcrumb;

export default defineStore(storeName, {
  state: () => {
    const initialData: Partial<StoreState> = window.initialData?.[storeName] || {};
    const state: StoreState = {
      items: [],
    };

    setInitialData(state, initialData);

    return state;
  },
  actions: {
    addBreadcrumbItem(data: Partial<BreadcrumbItem>) {
      if (this.items === null) {
        this.items = [];
      }

      this.items.forEach((item) => {
        item.active = true;
      });

      if (data !== null) {
        this.items.push(data as BreadcrumbItem);
      }
    },

    updateBreadcrumbCurrentItem(data: Partial<BreadcrumbItem>) {
      if (this.items === null) {
        this.items = [];
      }

      if (this.items.at(-1)) {
        this.items.pop();
      }

      this.items.push(data as BreadcrumbItem);
    },
  },
});
